import { useInsertStyles as C, warning as d, isIconDefinition as s, generate as f } from "../utils.js";
const r = {
  primaryColor: "#333",
  secondaryColor: "#E6E6E6",
  calculated: !1
};
function y({
  primaryColor: i,
  secondaryColor: n
}) {
  r.primaryColor = i, r.secondaryColor = n, r.calculated = !!n;
}
function m() {
  return {
    ...r
  };
}
const e = (i, n) => {
  const {
    icon: t,
    primaryColor: a,
    secondaryColor: c,
    ...u
  } = {
    ...i,
    ...n.attrs
  };
  let l = r;
  if (a && (l = {
    primaryColor: a,
    secondaryColor: c
  }), C(), d(s(t), `icon should be icon definiton, but got ${t}`), !s(t))
    return null;
  let o = t;
  return o && typeof o.icon == "function" && (o = {
    ...o,
    icon: o.icon(l.primaryColor, l.secondaryColor)
  }), f(o.icon, `svg-${o.name}`, {
    ...u,
    "data-icon": o.name,
    width: "1em",
    height: "1em",
    fill: "currentColor",
    "aria-hidden": "true"
  });
};
e.props = {
  icon: Object,
  primaryColor: String,
  secondaryColor: String,
  focusable: String
};
e.inheritAttrs = !1;
e.displayName = "IconBase";
e.getTwoToneColors = m;
e.setTwoToneColors = y;
export {
  e as default
};
